import React, { useEffect, useRef, useState } from 'react';
import { Button, Spin } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import moment from 'moment';
import { debounce } from 'lodash';
import Storage from '@/utils/storage';
import { queryNoticeAlert } from '@/api/systermNotice';
import { DATE_TIME_FORMAT } from '@/config';
import SysNoticeViewDrawer, {
  ISysViewDrawerRef,
} from '@/pages/manage/systemNoticeGroup/components/SysNoticeViewDrawer';

import styles from './SystermNotice.module.scss';

const Notice = () => {
  const [loading, setLoading] = useState(false);
  const [noticeQueue, setNoticeQueue] = useState<any[]>([]); // 公告队列

  const noticeViewDrawerRef = useRef<ISysViewDrawerRef>();
  const timerRef = useRef<any>(null);

  // 获取公告并放入队列
  const getNotice = async () => {
    try {
      setLoading(true);
      const res = await queryNoticeAlert();
      if (res.code === 0 && res.data) {
        setNoticeQueue((prevQueue) => {
          // 队列去重：只要队列中没有该id才加入
          if (prevQueue.some((item) => item?.id === res.data?.id)) {
            return prevQueue;
          }
          return [...prevQueue, res.data];
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // 首次加载和轮询
  useEffect(() => {
    getNotice();
    timerRef.current = setInterval(() => {
      getNotice();
    }, 90000); // 1.5分钟
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  // 关闭当前公告
  const handleClose = debounce(async () => {
    setNoticeQueue((prevQueue) => prevQueue.slice(1)); // 移除队首
    await getNotice();
  }, 300);

  // 查看公告
  const handleView = async () => {
    if (noticeQueue.length === 0) return;

    if (noticeQueue[0]) {
      noticeViewDrawerRef.current.openDrawer({
        id: noticeQueue[0]?.id,
        groupId: noticeQueue[0]?.groupId,
      });
    }

    setTimeout(() => {
      setNoticeQueue((prevQueue) => prevQueue.slice(1)); // 移除队首
      getNotice();
    }, 100);
  };

  // 只在门店测显示 集团端不展示
  const isGroupLogin = Storage.get('isGroupLogin');
  // if (isGroupLogin || noticeQueue.length === 0) return null;

  const currentNotice = noticeQueue[0];

  return (
    <Spin spinning={loading}>
      {isGroupLogin || noticeQueue.length === 0 ? null : (
        <div className={styles.notice}>
          <div className={styles.header}>
            系统公告
            <CloseOutlined
              style={{ color: '#666', cursor: 'pointer', fontSize: '16px' }}
              onClick={handleClose}
            />
          </div>
          <div className={styles.content}>
            <div className={styles.title}>{currentNotice?.title || ''}</div>
            <div className={styles.time}>
              发布时间：
              {currentNotice?.releaseTime
                ? moment(currentNotice?.releaseTime).format(DATE_TIME_FORMAT)
                : '-'}
            </div>
            <div className={styles.publisher}>
              发布人：{currentNotice?.releaseBy || ''}
              {currentNotice?.releaseName || ''}
            </div>
          </div>
          <div className={styles.footer}>
            <Button type="primary" style={{ marginRight: 12 }} onClick={() => handleView()}>
              查看
            </Button>
            <Button type="default" onClick={handleClose}>
              关闭
            </Button>
          </div>
        </div>
      )}

      <SysNoticeViewDrawer ref={noticeViewDrawerRef} showConfirm />
    </Spin>
  );
};

export default Notice;
